// extracted by mini-css-extract-plugin
export default {"container":"ColorField_container__KpfGc","dot":"ColorField_dot__hTu7f"};